/**
 * SOLID Review
 * S — Strong. One use case: the page loaded — the stored token's account, the tab's records, the URL, decided once.
 * O — Strong. What a start sets is the Domain's decision.
 * L — Strong. Implements its use-case role exactly.
 * I — Strong. `execute`.
 * D — Strong. The session's deps and the tab's records, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { ICommandStartSession, ICommandSessionStarted } from '../../domain/ports/schemas/SessionMoves';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { IConfigDepSession } from './IConfigDepSession';
import type { StoredRecords } from './StoredRecords';

export interface IConfigDepStartSession extends IConfigDepSession {
  readonly records: StoredRecords;
}

/** The page loaded (FE2; the token's half since FE3): who the stored token belongs to, the stored records, the URL. */
export class StartSessionUseCase implements IUseCase<ICommandStartSession, TPortOutcome> {
  constructor(private readonly deps: IConfigDepStartSession) {}

  async execute(ctx: IContextRequest, command: ICommandStartSession): Promise<TPortOutcome> {
    const { decisions, step, auth, records } = this.deps;
    const token = await auth.account(ctx);
    const started: ICommandSessionStarted = { intent: command, stored: await records.read(ctx), token: token.success ? token.value : null };
    return step.outcome(await step.run(ctx, (input) => decisions.sessionStarted(ctx, input, started)));
  }
}
